import { TRANSPARENT } from '../theme/settings';

export const overrides = {
    MuiFormControlLabel: {
        root: {
            marginLeft: 0
        }
    },
    MuiFormGroup: {
        root: {
            '&[role="radiogroup"] .MuiFormControlLabel-root .MuiRadio-root': {
                marginRight: 5
            }
        }
    },
    MuiRadio: {
        root: {
            border: `1px solid ${TRANSPARENT}`,
            boxShadow: `inset 0 2px 0 0 ${TRANSPARENT}`,
            '& + .MuiFormControlLabel-label': {
                fontSize: 'inherit'
            },
            '& .NeptuneRadio-icon': {
                position: 'absolute',
                background: TRANSPARENT,
                borderRadius: '50%'
            },
            '& .NeptuneRadio-checkedIcon': {
                position: 'absolute',
                left: '4px',
                right: '4px',
                top: '4px',
                bottom: '4px',
                background: TRANSPARENT,
                borderRadius: '50%'
            }
        }
    }
};
